<template>
<div id="root">  
     <div v-if="store.page.showTopNav" class="top-nav">
        <button class="desktop-back" type="button" @click="back()"><span class="icon-arrow-left2"></span></button>
        <div id="nav-title">
            <span>{{ store.page.title }}</span>
        </div>
     <img v-if="store && currentUser" class="global-sul-logo" src="img/sul-logo.svg" />
    </div>
    <div class="wrapper">
        <Suspense>
            <router-view />
            <template #fallback>
                <kk-spinner />
            </template>
        </Suspense>
    </div>
    <div v-if="currentUser" class="bottom-nav">
        <router-link to="/"><span class="bottom-nav-button icon-home"></span></router-link>
        <router-link v-if="store.selectedEvent" to="/invite-sponsor"><span class="bottom-nav-button icon-mail4"></span></router-link>
        <router-link v-if="store.selectedEvent" to="/add-sponsor"><span class="bottom-nav-button icon-user-plus"></span></router-link>
        <router-link v-if="store.selectedEvent" to="/sponsors"><span class="bottom-nav-button icon-users"></span></router-link>
        <router-link v-if="store.selectedOrganization && store.selectedEvent" to="/statistics/user"><span class="bottom-nav-button icon-stats-bars"></span></router-link>
        <router-link to="/myprofile"><span class="bottom-nav-button icon-cog"></span></router-link>
    </div>
    <kk-popup></kk-popup>
</div>
</template>
<script lang="ts">
import "es6-promise";
import axios, { AxiosError } from "axios";
import xamatron from "xamatron";

import { store } from "store";
import { getQueryStringArgs } from "common";

import { defineComponent } from "vue";

export default defineComponent({
    data() {
        return {
            store: store
        };
    },
    computed: {
        currentUser() {
            return store.currentUser;
        }
    },
    async created() {
        store.identity = {
            deviceId: this.getDeviceId(),
            accessToken: localStorage.getItem("accessToken") || null,
        };

        xamatron.setBackButtonHandler(() => this.back());

        xamatron.initialNotification

        this.initAxios();
        this.$router.push(store.identity.accessToken ? "/home" : "/start");

        await this.privacyPopup();
    },
    methods: {
        async privacyPopup() {
            let { showCookieInfo } = (await axios.get(`applicationsettings/cookie-info-status/${store.identity.deviceId}`)).data;
            if (showCookieInfo) {
                store.popup.title = ""
                store.popup.description = this.$t("loginView.cookieInfo") as string;
                store.popup.visible = true;
            }
        },
        initAxios(): void {
            axios.defaults.baseURL = getQueryStringArgs().apiurl || "https://kunniakierros.fi/api/v1/";

            axios.interceptors.request.use(config => {
                if (store.identity.accessToken)
                    config.headers["Authorization"] = "AccessToken " + store.identity.deviceId + " " + store.identity.accessToken;

                return config;
            });

            axios.interceptors.response.use(null, (err: AxiosError) => {
                if (err.response.status == 401) {
                    localStorage.removeItem("accessToken");
                    // alert("User authentication expired.");

                    location.reload();

                    store.popup.title = this.$t("loginView.authErrorTitle") as string;
                    store.popup.description = this.$t("loginView.authErrorDescription") as string;
                    store.popup.visible = true;
                }

                return Promise.reject(err);
            });
        },
        back() {
            if (this.$route.name == "HomeView" || this.$route.name == "Start") {
                xamatron.exitApplication();
            } else {
                this.$router.go(-1);
            }
        },
        getDeviceId(): string {
            let id = localStorage.getItem("deviceId");
            if (!id) {
                id = [...Array(32)].map(i => Math.floor(Math.random() * 16).toString(16)).join("");
                localStorage.setItem("deviceId", id);
            }

            return id;
        }
    }
})

</script>